import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function generateId(): string {
  return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
}

export function formatDate(timestamp: number): string {
  const date = new Date(timestamp);
  const now = new Date();
  const diff = now.getTime() - date.getTime();

  if (diff < 60000) return '刚刚';
  if (diff < 3600000) return `${Math.floor(diff / 60000)}分钟前`;
  if (diff < 86400000) return `${Math.floor(diff / 3600000)}小时前`;
  if (diff < 604800000) return `${Math.floor(diff / 86400000)}天前`;

  return date.toLocaleDateString('zh-CN');
}

export async function copyToClipboard(text: string): Promise<boolean> {

  try {


    if (
      navigator.clipboard &&
      window.isSecureContext
    ) {


      await navigator.clipboard.writeText(text);


    } else {


      const textarea =
        document.createElement('textarea');


      textarea.value = text;


      textarea.style.position = 'fixed';

      textarea.style.opacity = '0';


      document.body.appendChild(textarea);


      textarea.focus();

      textarea.select();


      document.execCommand('copy');


      document.body.removeChild(textarea);


    }


    return true;


  } catch (error) {


    console.error(
      '复制失败:',
      error
    );


    return false;


  }

}

export function downloadText(text: string, filename: string) {
  const blob = new Blob([text], { type: 'text/plain;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export function downloadJSON(data: unknown, filename: string) {
  const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export function getGrade(score: number): 'S' | 'A' | 'B' | 'C' | 'D' {
  if (score >= 90) return 'S';
  if (score >= 80) return 'A';
  if (score >= 70) return 'B';
  if (score >= 60) return 'C';
  return 'D';
}

export function getGradeColor(grade: string): string {
  const colors: Record<string, string> = {
    S: 'text-emerald-500 bg-emerald-50 dark:bg-emerald-900/20',
    A: 'text-blue-500 bg-blue-50 dark:bg-blue-900/20',
    B: 'text-yellow-500 bg-yellow-50 dark:bg-yellow-900/20',
    C: 'text-orange-500 bg-orange-50 dark:bg-orange-900/20',
    D: 'text-red-500 bg-red-50 dark:bg-red-900/20',
  };
  return colors[grade] || colors.D;
}
